const routes = [
    {
        path: "/toles/application/login",
        component: () => import("../pages/student/Login.vue"),
    },
    {
        path: "/toles/application/register",
        component: () => import("../pages/student/Register.vue"),
    },
    {
        path: "/toles/application/form",
        component: () => import("../pages/student/ApplicationFormIndex.vue"),
    },
    {
        path: "/toles/applications",
        component: () => import("../pages/admin/Index"),
        meta: {
            isAuthenticated: true,
            permission: "tolesapplication_index",
        },
    },
];

export default routes;
